<template>
  <div class="content-box">
    <div class="content">
  

        <div class="info">
            <span>這裏收錄了舊海關史料</span>
            <span class="number">{{ totaldata }}</span>
            <span>份在線資料</span>
        </div>
        <div class="search-select">
              <input 
              @keyup.enter="btnsearch"
              class="input" v-model="stxt"
                clearable
                placeholder="輸入關鍵詞搜索">
              <el-button class="search" @click="btnsearch"></el-button>
              <div class="gjjs">
                <router-link class="ro" :to="{ name: 'hgsearch' }">高級檢索></router-link>
              </div>
        </div>

        <div class="hot-fan">
          <div class="hot-search">
            <span>熱門搜索：</span>
            <span v-for="item in hotlist" :key="item" >
              <router-link  :to="{ name: 'hghome_searchresult',query: {searchtxt:item.txt}}">{{item.txt}}</router-link>
            </span>
          </div>
          <div style="display: none;" class="fanyi">
            <el-checkbox v-model="isfan">繁體、異體字</el-checkbox>
          </div>

        </div>

        

        <div class="line">
          <div class="sub-line"></div>
          <div class="sm-img"> 
            <img src="../assets/icon/hg.png"/>
          </div>
          <div class="sub-line"></div>
        </div>

        <div class="img-box-list">

          <div class="img-box">
            <img src="../assets/icon/list-img0.png" alt />
            <div>
              <li>實時檢索各類舊海關文獻在線閱讀、收藏</li>
            </div>
          </div>

          <div class="img-box">
            <img src="../assets/icon/list-img1.png" alt />
            <div>
              <li>邊讀邊記</li>
              <li>多表格對比研究</li>
            </div>
          </div>

          <div class="img-box">
            <img src="../assets/icon/list-img2.png" alt />
            <div>
              <li>在線寫作</li>
              <li>一鍵添加研究素材</li>
            </div>
          </div>

          <div class="img-box">
            <img src="../assets/image/list-img3.png" alt />
            <div>
              <li>豐富的舊海關領域文獻</li>
              <li>提供完備的數據分析工具庫</li>
            </div>
          </div>

        </div>

    </div>
  </div>
</template>



<script>
export default {
  name: "app",
  data() {
    return {
      totaldata:'',
      stxt:'',
      isfan:false,//是否包含繁体异体字
      hotlist: [
        {
          txt:'海關',
          addr:"#",
        },
        {
          txt:'進口',
          addr:"#",
        },
        {
          txt:'出口',
          addr:"#",
        },
        ],
    };
  },
  methods: {
    //点击搜索按钮
    btnsearch(){
      this.$router.push({ path: "/hghome_searchresult",query:{searchtxt:this.stxt,fan:this.isfan}});
    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
    this.$http
      .get(`${this.$store.state.baseurl}/api/hghome/getcount`)
      .then((res) => {
        //const json = res.data;
        this.totaldata=res.data;
       // const obj = JSON.parse(json);
      });
  },
};
</script>



<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  min-height:600px;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
}

.info {
  font-size: 24px;
  color: #000000;
  padding-top: 95px;
}

.info .number{
  color: #c60828;
  margin-left: 10px;
  margin-right: 10px;
}

.search-select {
  display: flex;
  justify-content: center;
  padding-top: 50px;
  .input {
    border-radius: 5px;
    width: 720px;
    height: 50px;
    padding-left: 20px;
    font-size: 14px;
    color: #999999;
    border: 0px;
  }
  
  
  .search {
    border-radius:5px;
    width: 110px;
    height: 50px;
    background: url("../assets/image/search.png") no-repeat;
    background-size:112px 50px;
    border-style: none;

  }
  .gjjs{
    font-size: 14px;
    padding-top: 15px;
    margin-left: 20px;
  }
  .gjjs .ro{
    text-decoration: none;
    color: #000;
  }
}

.hot-fan{
    display: flex;
    .fanyi {
      padding-top:23px;
      font-size: 14px;
    }
    .hot-search{
      text-align: left;
      padding-top:23px;
      padding-left: 150px;
      padding-right:150px;
      width: 400px;
      color: #666666;
      span{
        font-size: 14px;
      }
      a{
        font-size: 14px;
        margin-left: 14px;
        margin-right: 14px;
        text-decoration: none;
        color: #666666;

      }
    }

  }


.line{
 width:600px ;
 margin-top:100px;
 margin-bottom: 15px;
 margin-left: auto;
 margin-right: auto;
 display: flex;
 flex-direction: row;
 justify-content: start;
 flex-wrap: wrap;
 text-align: center;
  .sm-img{
    img{
      width: 40px;
      height: 40px;
    }
     
  }
  .sub-line{
    width: 250px;
    border-width: 0px 0px 1px 0px ;
    border-style: solid;
    border-color:#d8d6d1;
    margin-bottom: 20px;
  }
}

.img-box-list {
  width: 1220px;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .img-box {
    width: 280px;
    height: 350px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    text-align: left;
    img{
      width: 100px;
      height:100px;
      margin-left: auto;
      margin-right: auto;
    }
    li{
      padding-left: 32px;
      padding-right: 32px;
      color: #666666;
      line-height:28px;
      
    }
    
    }
  }


</style>